import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';

export const msgBox = css({ padding: '15px 0px', display: 'none' });
export const success = css({ color: colorsPalette.teal });
export const error = css({ color: colorsPalette.red });
export const phoneNumberFieldCssProps = {};
